import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRewrite1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRewrite1"><Path d="M6 1.91943L9.85078 5.00006L6 8.08068V6.00006H4V18.0001H12V20.0001H2V4.00006H6V1.91943Z" fill="currentColor"/><Path d="M12 4.00006V6.00006H20V18.0001H18V15.9194L14.1492 19.0001L18 22.0807V20.0001H22V4.00006H12Z" fill="currentColor"/><Path d="M8 9.00006H16V11.0001H8V9.00006Z" fill="currentColor"/><Path d="M8 13.0001V15.0001H14V13.0001H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRewrite1;
